import React from 'react';
import SimpleBar from 'simplebar-react';

import 'simplebar-react/dist/simplebar.min.css';
import '../Styles/Info.css';

export default function Info(props) {
	const { show, onToggle, language } = props;

	const wrapperClassName = `modal-info-wrapper ${show ? 'show' : ''}`;

	return (
		<div className={wrapperClassName}>
			<div className='modal-info'>
				<SimpleBar
					autoHide={false}
					style={{ maxHeight: '100%' }}
				>
					<div className="button-close" onClick={onToggle}></div>
					<div className="content">
						<div className="header">{(language) ? language['map:info:title'] : 'Info'}</div>
						<div
							className="description"
							dangerouslySetInnerHTML={{__html: (language) ? language['map:info:content'] : ''}}
						></div>
					</div>
				</SimpleBar>
			</div>
		</div>
	);
}